export const common = {
  appName: 'Planejamento de Alocação',
  sidebarTitle: 'Plan. de alocações',
  yes: 'Sim',
  no: 'Não',
  save: 'Salvar',
  cancel: 'Cancelar',
  close: 'Fechar',
  loading: 'Carregando...',
  pagination: {
    navigation: 'Paginação',
    previous: 'Página anterior',
    next: 'Próxima página',
    page: 'Página {{page}}',
  },
  sidebarToggle: 'Alternar barra lateral',
  datePicker: {
    previousMonth: 'Mês anterior',
    nextMonth: 'Próximo mês',
    previousYear: 'Ano anterior',
    nextYear: 'Próximo ano',
    previousDecade: 'Década anterior',
    nextDecade: 'Próxima década',
    today: 'Hoje',
    clear: 'Limpar',
    openCalendar: 'Abrir calendário',
    closeCalendar: 'Fechar calendário',
    selectDate: 'Selecionar data',
    selectRange: 'Selecionar período',
    selectMonth: 'Selecionar mês',
    selectYear: 'Selecionar ano',
    selectQuarter: 'Selecionar trimestre',
    selectWeek: 'Selecionar semana',
    selectTime: 'Selecionar horário',
    monthYearDropdown: 'Escolher mês e ano',
  },
  tableFilters: {
    trigger: 'Filtrar por {{column}}',
    triggerActive: 'Filtrar por {{column}} (filtro aplicado)',
    title: 'Filtrar {{column}}',
    apply: 'Aplicar',
    clear: 'Limpar',
    textPlaceholder: 'Contém…',
    textInputLabel: 'Texto para filtrar {{column}}',
    optionsSearchPlaceholder: 'Buscar…',
    optionsSearchLabel: 'Buscar em {{column}}',
    optionsEmpty: 'Nada encontrado para "{{query}}".',
    min: 'Mínimo',
    max: 'Máximo',
  },
  errors: {
    required: 'Campo obrigatório',
  },
  breadcrumb: 'Trilha de navegação',
  nav: {
    sidebar: 'Barra lateral',
    allocations: 'Alocações',
    checks: 'Consultas',
    pool: 'Pool',
    unallocated: 'Sem alocação',
    projects: 'Projetos',
    multiAllocated: 'Multialocados',
    summary: 'Síntese',
    percentageCheck: 'Conferência de %',
    allocationTags: 'Tags de alocação',
    language: 'Idioma',
    theme: 'Tema',
    userMenu: 'Menu do usuário',
  },
  themes: {
    light: 'Claro',
    dark: 'Escuro',
    system: 'Sistema',
  },
  notFound: {
    title: 'Página não encontrada',
    description: 'A página que você procura não existe ou foi movida.',
    back: 'Voltar para a página inicial',
  },
  errorBoundary: {
    title: 'Algo deu errado',
    description: 'Ocorreu um erro inesperado. Recarregue a página e tente novamente.',
    reload: 'Recarregar',
  },
} as const;
